export function BoldIcon() {
  return (
    <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden>
      <path d="M7 5h6a4 4 0 010 8H7z" />
      <path d="M7 13h7a4 4 0 010 8H7z" />
    </svg>
  );
}

export function ItalicIcon() {
  return (
    <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden>
      <path d="M10 4h9" />
      <path d="M5 20h9" />
      <path d="M14 4l-4 16" />
    </svg>
  );
}

export function UnderlineIcon() {
  return (
    <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden>
      <path d="M6 20h12" />
      <path d="M8 4v7a4 4 0 104 4 4 4 0 004-4V4" />
    </svg>
  );
}

export function AlignLeftIcon() {
  return (
    <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden>
      <path d="M4 6h16" />
      <path d="M4 10h10" />
      <path d="M4 14h14" />
      <path d="M4 18h8" />
    </svg>
  );
}

export function AlignCenterIcon() {
  return (
    <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden>
      <path d="M4 6h16" />
      <path d="M7 10h10" />
      <path d="M5 14h14" />
      <path d="M8 18h8" />
    </svg>
  );
}

export function AlignRightIcon() {
  return (
    <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden>
      <path d="M4 6h16" />
      <path d="M10 10h10" />
      <path d="M6 14h14" />
      <path d="M12 18h8" />
    </svg>
  );
}

export function LinkIcon() {
  return (
    <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden>
      <path d="M10 13a5 5 0 007.07 0l1.41-1.41a5 5 0 10-7.07-7.07L10 5" />
      <path d="M14 11a5 5 0 01-7.07 0L5.5 10.57a5 5 0 017.07-7.07L14 5" />
    </svg>
  );
}

export function ImageIcon() {
  return (
    <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M10 13l2-2 4 5H6l2-3 2 2z" />
      <circle cx="8" cy="9" r="1.5" />
    </svg>
  );
}

export function EyeIcon() {
  return (
    <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden>
      <path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}


